import React, { useState } from 'react'
import GridContainer from "@dashboard/common/src/components/Grid/GridContainer"
import '../textStyle.css'
import lock from '../../images/lock.png'
import drive from '../../images/drive.png'
import minus from '../../images/minus.png'
import share from  '../../images/share.png'
import DataSafetyDetails from './DataSafteyDetails'
import { Icon } from '@dashboard/common/src/component/Component'

const DataSafety = ({ setDialogOpen }) => {
    const [showDataSafetyDetails, setShowDataSafetyDetails] = useState(false)

    const showSafetyDetails = () =>{
        setShowDataSafetyDetails(true)
        setDialogOpen(true)
    }
    const hideSafteyDetails = () =>{
        setShowDataSafetyDetails(false)
        setDialogOpen(false)
    }
  return (
    <>
        <div className='textStyle' style={{ marginTop : 20}}>
            <div style={{ display: 'flex', width: '94%', alignItems: 'center', justifyContent: 'space-between'}}>
                    <h5>Data Safety</h5>
                    <button style={{ height: 30, fontSize: 20, width: 50, display: 'flex', justifyContent: 'center', background: 'none', border: 'none' }} onClick={showSafetyDetails}>
                        <Icon className="icon ni ni-arrow-right"></Icon>
                    </button>
            </div>
            <p style={{ marginTop: 5, fontSize: 14 }}>
            Safety starts with understanding how developers collect and share your data. Data privacy and security practices may vary based on your use, region and age The developer provided this information and may update it over time.
            </p>

            <GridContainer xs={11} sm={11} md={5} style={{ marginTop: 15, marginBottom: 25, display: 'flex', flexDirection: 'column', padding: 15, flexWrap: 'wrap', border: '1px solid #C0C0C0', borderRadius: 8 }}>
                <li style={{ display: 'flex', fontSize: 14, alignItems: 'center', listStyle: 'none', marginBottom: 12 }}>
                    <img src={share} style={{ height: 22, width: 22, marginRight: 15}} />
                    No data shared with third parties
                    {/* Learn more about how developers declare sharing */}
                </li>
                <li style={{ display: 'flex', fontSize: 14, alignItems: 'center', listStyle: 'none', marginBottom: 12 }}>
                    <img src={drive} style={{ height: 22, width: 22, marginRight: 15 }} />
                    This app may collect these data types
                    {/* Location, Personal info and 8 others */}
                </li>
                <li style={{ display: 'flex', fontSize: 14, alignItems: 'center', listStyle: 'none', marginBottom: 12 }}>
                    <img src={lock} style={{ height: 22, width: 22, marginRight: 15 }} />
                    Data is encrypted in transit
                </li>
                <li style={{ display: 'flex', fontSize: 14, alignItems: 'center', listStyle: 'none', marginBottom: 12 }}>
                    <img src={minus} style={{ height: 22, width: 22, marginRight: 15 }} />  
                    Data can’t be deleted
                </li>
            </GridContainer>
        </div>
        <DataSafetyDetails 
            showDataSafetyDetails={showDataSafetyDetails} 
            showSafetyDetails={showSafetyDetails} 
            hideSafteyDetails={hideSafteyDetails}
        />
    </>
  )
}

export default DataSafety